import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TracePlanStatusConstantType,
    TracePlanDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    TraceStatus
} from "../../type";

export const getTracePlanStatus = ({
    steps
}: TracePlanStatusConstantType): TraceStatus => {
    if(steps.some((step) => step.status === "error")) {
        return "error";
    }

    if(steps.some((step) => step.status === "cancelled")) {
        return "cancelled";
    }

    if(steps.length && steps.every((step) => step.status === "done")) {
        return "done";
    }

    return "running";
};

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        alignItems: "stretch",
        minWidth: 0
    },
    steps: {
        flexDirection: "column",
        alignItems: "stretch"
    }
});

export const useStyles = ({
    shapeConfigs,
    spaces
}: TracePlanDynamicStyleType) => {
    const styles = {
        progress: {
            maxWidth: shapeConfigs.cardWidth,
            paddingBottom: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
